// 全局组件注册插件
// 迁移自 main.js 中的全局组件注册

import Vue from 'vue'
// 图片上传组件 - 全局注册
import ImageUpload2 from '../components/ImageUpload2'

Vue.component('ImageUpload2', ImageUpload2)
